<template>
    <div class="section-box">
        <div class="detail" v-loading="loading">
             <div class="detail-top">
                 <div class="d-title">【{{serviceOffer.id}}】{{serviceOffer.serviceName}}</div>
             </div>
             <div class="detail-center">
                 <table>
                        <tr class="font-999">
                            <td>领域</td>
                            <td>一级产品</td>
                            <td>二级产品</td>
                            <td>三级产品</td>
                            <td>服务类型</td>
                            <td>类别</td>
                        </tr>
                        <tr class="font-666">
                            <td>{{serviceOffer.productDomainName}}</td>
                            <td>{{serviceOffer.oneProductName}}</td>
                            <td>{{serviceOffer.twoProductName}}</td>
                            <td>{{serviceOffer.threeProductName}}</td>
                            <td>{{serviceOffer.serviceStageName}}</td>
                            <td>{{serviceOffer.serviceType==1?'标准服务':'项目服务'}}</td>
                        </tr>
                    </table>
                 <div class="desc m-t-40 ourrow">
                     <el-row :gutter="24" style="margin-left: 0px">
                         <el-col :span="2">
                             <div class="font-666">服务描述：</div>
                         </el-col>
                         <el-col :span="20">
                             <div class="font-333">{{serviceOffer.content}}</div>
                         </el-col>
                     </el-row>
                 </div>
             </div>
             <div class="detail-bottom">
                 <el-tabs type="border-card" v-model="tabId" @tab-click="handleClick">
                     <el-tab-pane name="id_1" label="发单方价格" lazy v-if="serviceOffer.serviceType==1">
                         <div v-if="jddata">
                             <template v-if="settleType==0">
                                 <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                     <el-col :span="24">
                                         <span class="width_150">工作日价格：</span>{{jddata.workdayPrice}}元/天
                                     </el-col>
                                     <!-- <el-col :span="12">
                                         <span class="width_150">工作日会员价：</span>{{jddata.vipWorkdayPrice}}元/天
                                     </el-col> -->
                                 </el-row>
                                 <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                     <el-col :span="24">
                                         <span class="width_150">周末价格：</span>{{jddata.weekendPrice}}元/天
                                     </el-col>
                                     <!-- <el-col :span="12">
                                         <span class="width_150">周末会员价：</span>{{jddata.vipWeekendPrice}}元/天
                                     </el-col> -->
                                 </el-row>
                                 <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                     <el-col :span="24">
                                         <span class="width_150">节假日价格：</span>{{jddata.holidayPrice}}元/天
                                     </el-col>
                                     <!-- <el-col :span="12">
                                         <span class="width_150">节假日会员价：</span>{{jddata.vipHolidayPrice}}元/天
                                     </el-col> -->
                                 </el-row>
                             </template>
                             <template v-else>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">工作日价格：</span>
                                         <span>出发{{jddata.workdayDepartHourPrice}}元/小时/人，
                                               工作{{jddata.workdayWorkHourPrice}}元/小时/人，
                                               返程{{jddata.workdayBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">周末价格：</span>
                                         <span>出发{{jddata.weekendDepartHourPrice}}元/小时/人，
                                               工作{{jddata.weekendWorkHourPrice}}元/小时/人，
                                               返程{{jddata.weekendBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">节假日价格：</span>
                                         <span>出发{{jddata.workdayDepartHourPrice}}元/小时/人，
                                               工作{{jddata.workdayWorkHourPrice}}元/小时/人，
                                               返程{{jddata.workdayBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">工作日会员价：</span>
                                         <span>出发{{jddata.vipWorkdayDepartHourPrice}}元/小时/人，
                                               工作{{jddata.vipWorkdayWorkHourPrice}}元/小时/人，
                                               返程{{jddata.vipWorkdayBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">周末会员价：</span>
                                         <span>出发{{jddata.vipWeekendDepartHourPrice}}元/小时/人，
                                               工作{{jddata.vipWeekendWorkHourPrice}}元/小时/人，
                                               返程{{jddata.vipWeekendBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">节假日会员价：</span>
                                         <span>出发{{jddata.vipHolidayDepartHourPrice}}元/小时/人，
                                               工作{{jddata.vipHolidayWorkHourPrice}}元/小时/人，
                                               返程{{jddata.vipHolidayBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                             </template>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="24">
                                     <span class="width_150">工作日加班价格：</span>
                                     <span v-if="jddata.isWorkdayHasOvertimeSetting">{{jddata.workdayOverTimeBefore}}以前，{{jddata.workdayOverTimeAfter}}以后，
                                         每小时{{jddata.workdayOverTimeHourPrice }}元/小时</span>
                                     <span v-else>无</span>
                                 </el-col>
                             </el-row>
                             <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                 <el-col :span="24">
                                     <span class="width_150">周末加班：</span>
                                     <span v-if="jddata.isWeekendHasOvertimeSetting">{{jddata.weekendOverTimeBefore }}以前，{{jddata.weekendOverTimeAfter }}以后，
                                     每小时{{jddata.weekendOverTimeHourPrice}}元/小时</span>
                                     <span v-else>无</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="24">
                                     <span class="width_150">节假日加班：</span>
                                     <span v-if="jddata.isHolidayHasOvertimeSetting">
                                         {{jddata.holidayOverTimeBefore}}以前，{{jddata.holidayOverTimeAfter}}以后，
                                     每小时{{jddata.holidayOverTimeHourPrice}}元/小时</span>
                                     <span v-else>无</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around" v-if="settleType==1">
                                 <el-col :span="24">
                                     <span class="width_150">扣除1小时价格：</span>
                                     <span v-if="jddata.isDeductOneHourPrice">{{jddata.deductionOneHourBTime}}~{{jddata.deductionOneHourETime}}</span>
                                     <span v-else>否</span>
                                 </el-col>
                             </el-row>
                             <div class="border-2"></div>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="12">
                                     <span class="width_150">同城补助：</span>
                                     <span>{{bzSwitch(jddata.citySubsidy)}} </span>
                                     <span v-if="jddata.citySubsidy==4" class="mar-l-22">{{jddata.cityFixedSubsidy}}元/天/人</span>
                                 </el-col>
                                 <el-col :span="12">
                                     <span class="width_150">异地补助：</span>
                                     <span>{{bzSwitch(jddata.diffCitySubsidy)}}</span>
                                     <span v-if="jddata.diffCitySubsidy==4" class="mar-l-22">{{jddata.diffCityFixedSubsidy}}元/天/人</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="12">
                                     <span class="width_150">发单方价格：</span>
                                     <span>{{jddata.isTaxIncluded?'含税':'不含税'}}</span>
                                 </el-col>
                                 <el-col :span="12">
                                     <span class="width_150">特殊地区涨幅：</span>
                                     <span>{{jddata.specialPlaceIncreaseRate}}%</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="24" class="flex">
                                     <div class="width_150">特殊地区：</div>
                                     <div class="area-item" v-for="(item,index) in jddata.specialPlace" :key="index">
                                         <span>{{item.cityName || item.provinceName}}</span>
                                         <span v-if="jddata.specialPlace.length>1&&jddata.specialPlace.length-index>1">、</span>
                                     </div>
                                 </el-col>
                             </el-row>
                         </div>
                     </el-tab-pane>
                     <el-tab-pane name="id_2" label="接单方价格" lazy v-if="serviceOffer.serviceType==1">
                         <div v-if="fddata">
                             <template v-if="settleType==0">
                                 <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                     <el-col :span="24">
                                         <span class="width_150">工作日价格：</span>
                                         <span>{{fddata.workdayPrice}}元/天</span>
                                     </el-col>
                                 </el-row>
                                 <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                     <el-col :span="24">
                                         <span class="width_150">周末价格：</span>
                                         <span>{{fddata.weekendPrice}}元/天</span>
                                     </el-col>
                                 </el-row>
                                 <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                     <el-col :span="24">
                                         <span class="width_150">节假日价格：</span>
                                         <span>{{fddata.holidayPrice}}元/天</span>
                                     </el-col>
                                 </el-row>
                             </template>
                             <template v-else>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">工作日价格：</span>
                                         <span>出发{{fddata.workdayDepartHourPrice}}元/小时/人，
                                               工作{{fddata.workdayWorkHourPrice}}元/小时/人，
                                               返程{{fddata.workdayBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">周末价格：</span>
                                         <span>出发{{fddata.weekendDepartHourPrice}}元/小时/人，
                                               工作{{fddata.weekendWorkHourPrice}}元/小时/人，
                                               返程{{fddata.weekendBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                                 <el-row type="flex" class="row-bg" justify="space-around" :gutter="20">
                                     <el-col :span="24">
                                         <span class="width_150">节假日价格：</span>
                                         <span>出发{{fddata.workdayDepartHourPrice}}元/小时/人，
                                               工作{{fddata.workdayWorkHourPrice}}元/小时/人，
                                               返程{{fddata.workdayBackHourPrice}}元/小时/人
                                         </span>
                                     </el-col>
                                 </el-row>
                             </template>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="24">
                                     <span class="width_150">工作日加班价格：</span>
                                     <span v-if="fddata.isWorkdayHasOvertimeSetting">{{fddata.workdayOverTimeBefore}}以前，{{fddata.workdayOverTimeAfter}}以后，
                                         每小时{{fddata.workdayOverTimeHourPrice }}元/小时</span>
                                     <span v-else>无</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="24">
                                     <span class="width_150">周末加班：</span>
                                     <span v-if="fddata.isWeekendHasOvertimeSetting">{{fddata.weekendOverTimeBefore }}以前，{{fddata.weekendOverTimeAfter }}以后，
                                     每小时{{fddata.weekendOverTimeHourPrice}}元/小时</span>
                                     <span v-else>无</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="24">
                                     <span class="width_150">节假日加班：</span>
                                     <span v-if="fddata.isHolidayHasOvertimeSetting">
                                         {{fddata.holidayOverTimeBefore}}以前，{{fddata.holidayOverTimeAfter}}以后，
                                     每小时{{fddata.holidayOverTimeHourPrice}}元/小时</span>
                                     <span v-else>无</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around" v-if="settleType==1">
                                 <el-col :span="24">
                                     <span class="width_150">扣除1小时价格：</span>
                                     <span v-if="fddata.isDeductOneHourPrice">{{fddata.deductionOneHourBTime}}~{{fddata.deductionOneHourETime}}</span>
                                     <span v-else>否</span>
                                 </el-col>
                             </el-row>
                             <div class="border-2"></div>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="12">
                                     <span class="width_150">同城补助：</span>
                                     <span>{{bzSwitch(fddata.citySubsidy)}} </span>
                                     <span v-if="fddata.citySubsidy==4" class="mar-l-22">{{fddata.cityFixedSubsidy}}元/天/人</span>
                                 </el-col>
                                 <el-col :span="12">
                                     <span class="width_150">异地补助：</span>
                                     <span>{{bzSwitch(fddata.diffCitySubsidy)}}</span>
                                     <span v-if="fddata.diffCitySubsidy==4" class="mar-l-22">{{fddata.diffCityFixedSubsidy}}元/天/人</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="12">
                                     <span class="width_150">发单方价格：</span>
                                     <span>{{fddata.isTaxIncluded?'含税':'不含税'}}</span>
                                 </el-col>
                                 <el-col :span="12">
                                     <span class="width_150"> 特殊地区涨幅：</span>
                                     <span>{{fddata.specialPlaceIncreaseRate}}%</span>
                                 </el-col>
                             </el-row>
                             <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                                 <el-col :span="24" class="flex">
                                     <div class="width_150">特殊地区：</div>
                                     <div class="area-item" v-for="(item,index) in fddata.specialPlace" :key="index">
                                         <span>{{item.cityName || item.provinceName}}</span>
                                         <span v-if="fddata.specialPlace.length>1&&fddata.specialPlace.length-index>1">、</span>
                                     </div>
                                 </el-col>
                             </el-row>
                         </div>
                     </el-tab-pane>
                     <el-tab-pane name="id_3" label="特殊要求" lazy>
                         <div v-for="(item,index) in specialInfos" :key="index">
                             <div class="title">{{item.title}}<span v-if="item.isRequired" class="redxin">*</span></div>
                             <div v-if="item.problemType==1" class="m-t-b-20">
                                 <el-radio-group v-model="item.rddiocurrentOption">
                                     <el-radio v-for="(item2,index2) in item.problemOptions" :key="index2"  :label="item2.sortNo" disabled :class="item2.isChecked?'checkedclass':''">
                                         {{item2.content}}
                                     </el-radio>
                                 </el-radio-group>
                             </div>
                             <div v-if="item.problemType==2"  class="m-t-b-20">
                                 <el-checkbox-group v-model="item.currentOption">
                                     <el-checkbox v-for="(item2,index2) in item.problemOptions" :key="index2" :label="item2.sortNo" disabled>
                                         {{item2.content}}
                                     </el-checkbox>
                                 </el-checkbox-group>
                             </div>
                             <div v-if="item.problemType==3"  class="m-t-b-20">
                                 <el-input type="textarea" disabled maxlength="1000" ></el-input>
                             </div>
                         </div>
                         <div v-if="!specialInfos.length" style="display: flex;align-items: center;justify-content: center;">
                            <div style="text-align: center;">
                                <svg 
                                    t="1665303091989" 
                                    class="icon" 
                                    viewBox="0 0 1024 1024" 
                                    version="1.1" 
                                    p-id="1800" 
                                    width="200" 
                                    height="200"
                                >
                                    <path d="M512 896c-211.7 0-384-172.3-384-384s172.3-384 384-384 384 172.3 384 384-172.3 384-384 384z m0-682.7c-164.7 0-298.7 134-298.7 298.7s134 298.7 298.7 298.7 298.7-134 298.7-298.7-134-298.7-298.7-298.7z" p-id="1801" fill="#e6e6e6"></path>
                                    <path d="M512 573.5c-23.6 0-42.7-19.1-42.7-42.7V342.2c0-23.6 19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7v188.6c0 23.7-19.1 42.7-42.7 42.7zM512 724.5c-23.6 0-42.7-19.1-42.7-42.7v-22.3c0-23.6 19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7v22.3c0 23.6-19.1 42.7-42.7 42.7z" p-id="1802" fill="#e6e6e6"></path>
                                </svg>
                                <br/>
                                <span style="font-size: 18px;color: #999;font-weight: 600;">未设置特殊需求</span>
                            </div>
                         </div>
                     </el-tab-pane>
                     <el-tab-pane name="id_4" label="服务确认" lazy>
                         <div v-for="(item,index) in confirmInfos" :key="index" class="underline">
                             <div class="h1-title">服务确认{{index+1}} 一【{{item.moduleName}}】</div>
                             <div v-for="(item2,index2) in item.subsets" :key="index2">
                             <div class="h2-title">子集{{index2+1}} 一 {{item2.subsetName}}</div>
                             <div v-for="(item3,index3) in item2.subsetContents" :key="index3">
                                 <div class="title">{{item3.title}}<span v-if="item3.isRequired" class="redxin">*</span></div>
                                 <div v-if="item3.problemType==1" class="m-t-b-20">
                                     <el-radio-group v-model="item3.rddiocurrentOption">
                                         <el-radio v-for="(item4,index4) in item3.problemOptions" :key="index4"
                                                   :label="item4.sortNo" disabled :class="item4.isChecked?'checkedclass':''">
                                             {{item4.content}}
                                         </el-radio>
                                     </el-radio-group>
                                 </div>
                                 <div v-if="item3.problemType==2"  class="m-t-b-20">
                                     <el-checkbox-group v-model="item3.currentOptionaa">
                                         <el-checkbox v-for="(item4,index4) in item3.problemOptions" :key="index4" :label="item4.sortNo" disabled>
                                             {{item4.content}}
                                         </el-checkbox>
                                     </el-checkbox-group>
                                 </div>
                                 <div v-if="item3.problemType==3"  class="m-t-b-20">
                                     <el-input type="textarea" disabled maxlength="1000" ></el-input>
                                 </div>
                             </div>
                             </div>
                         </div>
                         <div v-if="!confirmInfos.length" style="display: flex;align-items: center;justify-content: center;">
                            <div style="text-align: center;">
                                <svg 
                                    t="1665303091989" 
                                    class="icon" 
                                    viewBox="0 0 1024 1024" 
                                    version="1.1" 
                                    p-id="1800" 
                                    width="200" 
                                    height="200"
                                >
                                    <path d="M512 896c-211.7 0-384-172.3-384-384s172.3-384 384-384 384 172.3 384 384-172.3 384-384 384z m0-682.7c-164.7 0-298.7 134-298.7 298.7s134 298.7 298.7 298.7 298.7-134 298.7-298.7-134-298.7-298.7-298.7z" p-id="1801" fill="#e6e6e6"></path>
                                    <path d="M512 573.5c-23.6 0-42.7-19.1-42.7-42.7V342.2c0-23.6 19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7v188.6c0 23.7-19.1 42.7-42.7 42.7zM512 724.5c-23.6 0-42.7-19.1-42.7-42.7v-22.3c0-23.6 19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7v22.3c0 23.6-19.1 42.7-42.7 42.7z" p-id="1802" fill="#e6e6e6"></path>
                                </svg>
                                <br/>
                                <span style="font-size: 18px;color: #999;font-weight: 600;">未设置服务确认</span>
                            </div>
                         </div>
                     </el-tab-pane>
                     <el-tab-pane name="id_5" label="匹配机制" lazy>
                         <div v-if="matchConfig">
                             <div>
                                 <span class="m-r-40 width_150">证书要求：</span>
                                 <span v-if="matchConfig.certificates">
                                     <span v-for="(item,index) in matchConfig.certificates" :key="index">{{item.certificateName}}
                                         <span v-if="matchConfig.certificates.length>1&&matchConfig.certificates.length-index>1">、</span>
                                    </span>
                                 </span>
                                 <span v-else>--</span>

                             </div>
                             <div class="m-t-40">
                                 <span class="m-r-40 width_150">服务标签：</span>
                                 <span>{{fwSwitch(matchConfig.serviceLabelAuthType)}}</span>；
                                 <span>{{matchConfig.isServiceLabelPractical==0?'无需实操认证':'需要实操认证'}}</span>
                             </div>
                             <div class="m-t-40">
                                 <span class="m-r-40 width_150">产品品牌标签：</span>
                                 <span>{{fwSwitch(matchConfig.productBrandAuthType)}}</span>；
                                 <span>{{matchConfig.isProductBrandPractical==0?'无需实操认证':'需要实操认证'}}</span>；
                                 <span>{{matchConfig.isOriginAuthRequired==0?'无需原厂认证':'需原厂认证'}}</span>
                             </div>
                         </div>
                     </el-tab-pane>
                 </el-tabs>
             </div>
             <div class="detail-right">
                 <rightoffer-box v-if="serviceOffer" @refreshList="successReply" :serviceOffer="serviceOffer"></rightoffer-box>
             </div>
        </div>
    </div>
</template>

<script>
    import {getoffterDetail} from "@/service/dataFrame";
    import rightofferBox from './index/rightofferBox';
    export default {
        name: "serviceDetails",
        components:{rightofferBox},
        data(){
            return{
                loading:false,
                tabId: 'id_1',
                serviceOffer:{},
                jddata:{},
                fddata:{},
                specialInfos:[],
                settleType:-1,
                confirmInfos:[],
                matchConfig:[],
            }
        },
        methods:{
            successReply(){
                this.queryDetail();
            },
            handleClick(){

            },
            bzSwitch(val){
                let content=''
                switch (val) {
                    case 1:
                        content = '无补助';
                        break;
                    case 2:
                        content = '实报实销';
                        break;
                    case 3:
                        content = '速派规则';
                        break;
                    case 4:
                        content = '固定补助';
                        break;
                }
                return content
            },
            fwSwitch(val){
                let content=''
                switch (val) {
                    case 0:
                        content = '无认证';
                        break;
                    case 1:
                        content = '速派初级认证';
                        break;
                    case 2:
                        content = '速派中级认证';
                        break;
                    case 3:
                        content = '速派高级认证';
                        break;
                }
                return content
            },
            async queryDetail(){
                this.loading=true;
                let res = await getoffterDetail(this.$route.query.id)
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.serviceOffer = res.Data.serviceOffer;
                if(this.serviceOffer.serviceType!=1){
                    this.tabId='id_3';
                }else{
                    if(res.Data.settleType==0){
                        this.jddata = res.Data.dailySettlement.billConfiguration;
                        this.fddata = res.Data.dailySettlement.orderTakingConfiguration;
                        // console.log(this.jddata)
                    }else{
                        this.jddata = res.Data.hourlySettlement.billConfiguration;
                        this.fddata = res.Data.hourlySettlement.orderTakingConfiguration;
                    }
                }
                this.settleType= res.Data.settleType;
                let arr = res.Data.specialInfos || [];
                for(let i=0;i<arr.length;i++) {
                    let arr2 =arr[i].problemOptions;
                    if(arr[i].problemType==1) {
                        this.$set(arr[i],'rddiocurrentOption','')
                    }
                    if(arr[i].problemType==2) {
                        this.$set(arr[i],'currentOption', [])
                    }
                    for(let i2=0;i2<arr2.length;i2++) {
                        if(arr2[i2].isChecked){
                            if(arr[i].problemType==1){
                                arr[i].rddiocurrentOption=arr2[i2].sortNo;
                            }
                            if(arr[i].problemType==2){
                                arr[i].currentOption.push(arr2[i2].sortNo);
                            }
                        }
                    }
                }
                this.specialInfos = arr;
                let arr2 = res.Data.confirmInfos;
                for(let i2=0;i2<arr2.length;i2++) {
                    let arr3 = arr2[i2].subsets
                    for (let i3 = 0; i3 < arr3.length; i3++) {
                        let arr4 = arr3[i3].subsetContents;
                        for (let i4 = 0; i4 < arr4.length; i4++) {
                            let arr5 = arr4[i4].problemOptions;
                            if(arr4[i4].problemType==1){
                                this.$set(arr4[i4],'rddiocurrentOption','')
                            }
                            if(arr4[i4].problemType==2){
                                this.$set(arr4[i4],'currentOptionaa', [])
                            }
                            for(let i5=0;i5<arr5.length;i5++){
                                if(arr5[i5].isChecked){
                                    if(arr4[i4].problemType==1){
                                        arr4[i4].rddiocurrentOption=arr5[i5].sortNo;
                                    }
                                    if(arr4[i4].problemType==2){
                                        arr4[i4].currentOptionaa.push(arr5[i5].sortNo);
                                    }
                                }
                            }
                        }
                    }
                }
                this.confirmInfos = arr2;
                // console.log("this.confirmInfos",this.confirmInfos)
                this.matchConfig = res.Data.matchConfig;
                setTimeout(()=>{
                    this.loading=false;
                },1000)
                // console.log('res',this.matchConfig)
            }
        },
        activated(){
            this.queryDetail();
        },
        created() {
            this.queryDetail();
            // alert(this.$route.query.id)
        }
    }
</script>

<style lang="scss">
    .detail{
        position: relative;
        padding: 4px;
        word-break: break-all;
        .detail-top{
            .d-title{
                font-size: 34px;
                font-weight: 400;
                color: #333333;
                width: 70%;
                word-break: break-word;
            }
        }
        .detail-center{
            margin-top: 39px;
            max-width:1120px;
            table{
                border-collapse: collapse;
                font-size: 19px;
            }
            td{
                width: 182px;
                height: 52px;
                background: #FFFFFF;
                text-align: center;
                /*line-height: 52px;*/
                border: 1px solid #E5E5E5;
            }
            .desc{
                font-size: 16px;
            }
            .ourrow{
                .el-col{
                    padding-left: 0px!important;
                    padding-right: 0px!important;
                    word-break: break-all;
                }
            }
        }
        .detail-bottom{
            margin-top: 60px;
            max-width: 1110px;
            .flex{
                display: flex;
            }
            .width_150{
                width: 150px;
                /*background: red;*/
                display: inline-block;
            }
            .underline{
                border-bottom: 1px solid #E5E5E5;
            }
            .redxin{
                color: red;
                margin-left: 10px;
            }
            .h1-title{
                font-size: 25px;
                font-weight: bold;
                margin-bottom: 20px;
            }
            .h2-title{
                font-size: 22px;
                font-weight: bold;
                margin-bottom: 20px;
            }
            .title{
                font-weight: bold;
                font-size: 19px;
            }
            .el-tabs--border-card{
                border:none;
                box-shadow:none;
            }
            .el-tabs--border-card>.el-tabs__header{
                background: #FFFFFF;
            }
            .el-tabs__nav{
                border: 1px solid #E5E5E5;
                border-bottom-color: #FFF;
            }
            .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
                background-color: #fff;
                border-top: 2px solid #2D8CEF;
                border-bottom-color: #FFF
            }
            .el-tabs__item{
                width: 158px;
                text-align: center;
                border-bottom-color:#E5E5E5;
            }
            .el-tabs--border-card>.el-tabs__content{
                padding: 57px 0 15px;
            }
            .el-row{
                margin-bottom: 37px;
            }
            .border-2{
                margin-top: 10px;
                margin-bottom: 47px;
                border-bottom: 2px solid #F5F7F9;
            }
            .row-bg{
                background-color: #ffffff;
            }
            .el-radio__input.is-disabled .el-radio__inner::after{
                background-color: #FFF!important;
            }
            .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner{
                background-color: #FFF!important;
                border-color: #DCDFE6!important;
            }
            .el-radio__input.is-disabled+span.el-radio__label{
                color: #606266!important;
            }
            .el-checkbox__input.is-disabled+span.el-checkbox__label{
                color: #606266!important;
            }
            .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
                background-color: #409EFF!important;
                border-color: #409EFF!important;
            }
            .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
                border-color: white!important;
            }
            .el-textarea{
                width: 400px!important;
            }
            .checkedclass{
                .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
                    background-color: #409EFF!important;
                }
                .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner{
                    background-color: #409EFF!important;
                    border-color: #409EFF!important;
                }
            }
        }
        .detail-right{
            position: absolute;
            right: 20px;
            top: 29px;
            width: 431px;
        }
        .m-t-40{
            margin-top: 40px;
        }
        .m-t-b-20{
            margin-top: 20px;
            margin-bottom: 20px;
            .el-radio__input{
                vertical-align: top!important;
            }
            .el-checkbox__input{
                vertical-align: top!important;
            }
            .el-radio__label{
                font-size: 19px;
                width: 500px;
                display: inline-block;
                margin-bottom: 20px;
                overflow: hidden;//溢出隐藏
                white-space: nowrap;//禁止换行
                text-overflow: ellipsis;//...
            }
            .el-checkbox__label{
                font-size: 19px;
                width: 500px;
                overflow: hidden;//溢出隐藏
                white-space: nowrap;//禁止换行
                text-overflow: ellipsis;//...
                margin-bottom: 20px;
            }
        }
        .font-999{
            color: #999999;
        }
        .font-666{
            color: #666666;
        }
        .font-333{
            color: #333333;
            font-weight: 400;
        }
        .mar-l-22{
            margin-left:22px;
        }
        .m-r-40{
            margin-right: 40px;
        }
    }

</style>
